<template>
  <div class="home">
    Bienvenue sur le backoffice de Chez Nestor
  </div>
</template>

<script>
export default {
  name: 'home',
};
</script>
